export enum ObservableEventTypes {
  ROW_SWIPE,
  CHART_PRESS,
  PORTFOLIO_TAB_CHANGE,
}

type ObservableData<T> = {
  data?: T;
  key: string;
};

export type ObservableEventData<T> = ObservableData<T> & {
  eventType: ObservableEventTypes;
};

export enum WebSocketEventTypes {
  LOGIN_TIMEOUT = 'LOGIN_TIMEOUT',
  CLOSED = 'CONNECTION_CLOSED',
  ERROR = 'ERROR',
  UNKNOWN_RESPONSE = 'UNKNOWN_WEBSOCKET_RESPONSE',
  PARSED_RESPONSE = 'PARSED_WEBSOCKET_RESPONSE',
}

export type WebSocketEventData<T> = ObservableData<T> & {
  eventType: WebSocketEventTypes;
};
